import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SlideShow } from "@/components/SlideShow";

/** Renders all active slides configured for a given placement key. */
export function SlidePlacement({ where }) {
  const [slides, setSlides] = useState([]);
  useEffect(() => {
    api.get(`/slides?placement=${encodeURIComponent(where)}`)
      .then(({ data }) => setSlides((data || []).filter((s) => s.is_active && ((s.products || []).length || (s.type === "image" && (s.images || []).length)))))
      .catch(() => {});
  }, [where]);

  if (!slides.length) return null;
  return (
    <div className="mx-auto max-w-7xl space-y-6 px-4 py-6" data-testid={`slide-placement-${where}`}>
      {slides.map((s) => <SlideShow key={s.id} slide={s} />)}
    </div>
  );
}
